import gql from "graphql-tag";

export const GET_DOWNLOAD_INFO = gql`
    mutation downloadPhoto($photoId: ID!, $downloadType: PhotoDownloadType!) {
        downloadPhoto(photoId: $photoId, downloadType: $downloadType) {
            downloadUrl
            ok
            errors
        }
    }
`;
